import loadable from '@loadable/component';

import { MapFullscreenFallback } from '../../components/MapFallback';

export const MapContainerLoadable = loadable(() => import('./MapContainer'), {
  fallback: <MapFullscreenFallback />,
});
